import { atom } from 'jotai';
import { PolygonProps } from '@fabric-web/3d-viewer';
import {
  DataLoaderPointOfInterestQueryObject,
  BlisterToAdd,
  EditPointOfInterest,
  PointOfInterestQuery,
  AllPointOfInterestTemplate,
} from '@/types';
import { Maybe } from 'graphql/jsutils/Maybe';
import { ImageType, SelectedPointOfInterestQuery, Vector3 } from '@/__generated__/graphql';
import { Attachment } from '@/components/Analysis/modules/pointOfInterest/PointOfInterestTab/SelectedPoiContent/types';
export const poiFilteredByCheckbox = atom<PointOfInterestQuery>([]);

export const selectedPointOfInterestId = atom<string | undefined>(undefined);
export const selectedPointOfInterest = atom<
  SelectedPointOfInterestQuery['pointOfInterest'] | undefined
>(undefined);

export const editPointOfInterest = atom<EditPointOfInterest>({ state: 'Inactive' });

export const blisterToAdd = atom<BlisterToAdd | undefined>(undefined);

export const structurePois = atom<DataLoaderPointOfInterestQueryObject>([]);

export const blisterPolygons = atom<PolygonProps[] | undefined>(undefined);

export const manualBlisterHeightExists = atom<boolean>(false);

export const selectedTemplate = atom<AllPointOfInterestTemplate[0] | undefined>(undefined);

export const defectsList = atom<Array<{ key: string; value: string }>>([]);

export const isEvaluatingFields = atom<boolean>(false);

export const newPointOfInterestCenterPoint3d = atom<Maybe<Vector3> | undefined>(undefined);

export const poiAttachmentsAtom = atom<Attachment[]>([]);

export const pendingRemovalIdsAtom = atom<Set<string>>(new Set<string>());

export const attachmentsAwaitingUrl = atom<Set<string>>(new Set<string>());

export const preInspectionImagesAtom = atom<Attachment[]>((get) => {
  const all = get(poiAttachmentsAtom);
  return all.filter(
    (a) => a.imageType !== ImageType.PostInspection && a.imageType !== ImageType.WhiteBgPdf
  );
});

export const postInspectionImagesAtom = atom<Attachment[]>((get) => {
  const all = get(poiAttachmentsAtom);
  return all.filter((a) => a.imageType === ImageType.PostInspection);
});

export const bulkEditDrawerOpen = atom(false);
